import { NavLink } from "@/components/NavLink";
import { User, Sliders } from "lucide-react";

const menuItems = [
  { icon: User, label: "Account", path: "/settings/account" },
  { icon: Sliders, label: "Preferences", path: "/settings/preferences" },
];

export const SettingsSidebar = () => {
  return (
    <aside className="w-full md:w-64 flex-shrink-0">
      {/* Mobile: Horizontal scroll tabs */}
      <nav className="flex md:hidden overflow-x-auto gap-2 pb-4 border-b mb-6">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="flex items-center gap-2 px-4 py-2 text-sm rounded-full whitespace-nowrap text-foreground/70 hover:text-black dark:hover:text-white transition-colors border border-border"
            activeClassName="text-black dark:text-white border-foreground/20"
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      
      {/* Desktop: Vertical sidebar */}
      <nav className="hidden md:block space-y-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="flex items-center gap-3 px-3 py-2 text-sm rounded-md text-foreground/70 hover:text-black dark:hover:text-white transition-colors"
            activeClassName="text-black dark:text-white"
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};
